import { CountryCode, getCountries, getCountryCallingCode } from 'libphonenumber-js/min';
import { useMemo } from 'react';
import { SelectOption } from 'shared/components/Select/Select';

export const DEFAULT_PREFIX = '48';
const getPrefix = (countryCode: CountryCode): string => getCountryCallingCode(countryCode);

export const usePhoneNumberInput = () => {
  const prefixOptions: SelectOption<string>[] = useMemo(() => {
    const countries = getCountries();
    const prefixSet = new Set<string>();

    countries.forEach((country) => {
      prefixSet.add(getPrefix(country));
    });

    return Array.from(prefixSet).map((prefix) => ({
      value: prefix,
      label: `+${prefix}`,
    }));
  }, []);

  const defaultPrefixOption: SelectOption<string> | undefined = useMemo(() => {
    return prefixOptions.find((option) => option.value === DEFAULT_PREFIX) ?? prefixOptions[0];
  }, [prefixOptions]);

  return {
    prefixOptions,
    defaultPrefixOption,
  };
};
